export const generateBadgeSizeOption = (size: number) => {
  return size >= 0
    ? Array.from(Array(size).keys(), (i) => i + 1).map((i) => ({
        value: i + 'px',
        label: i.toString(),
      }))
    : [];
};
